import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as salesCatalystActions from '../../../actions/salesCatalystActions';
import Charts from '../../common/Charts/Charts';
import { processBubbleChartData } from '../../../util/SalesCatalystUtils';
import CommonDropdown from '../../common/CommonDropdown';
import { SC_BASE, SC_TARGET_MARKET, SC_BASE_MARKET_SELECTOR_VAL, SC_COMPETITORS_ACTIVITIES,
  SC_SCATTERPLOT_SC } from '../../../constants';
import { NO_DATA_AVAILABLE_MSG } from '../../../messages/messages';
import SalesCatalystSectionBottom from '../SalesCatalystSectionBottom';

class SalesCatalystCompetitionBubbleChart extends Component {
  constructor(props) {
    super(props);
    const baseMarketSelectorValSelected = this.getBaseMarketSelectorValForGivenFamilyId(this.props.baseMarketSelectorVal);
    this.state = {
      chartData: processBubbleChartData(this.props.studyInfo, this.props.data, this.props.color),
      activitiesDefaultVal: this.props.data !== undefined ?
        _.find(this.props.activitiesListData, o =>
        _.camelCase(o.label) === _.camelCase(this.props.data.label)) : undefined,
      baseMarketOptions: [
        { label: this.props.scBase !== undefined ? this.props.scBase.label : undefined, value: SC_BASE },
        { label: this.props.targetMarket[0] !== undefined ? this.props.targetMarket[0].label : undefined, value: SC_TARGET_MARKET },
      ],
      baseMarketDefaultVal: { label: (baseMarketSelectorValSelected === undefined || baseMarketSelectorValSelected === SC_BASE) && this.props.scBase !== undefined ? this.props.scBase.label : this.props.targetMarket[0].label,
        value: (baseMarketSelectorValSelected === undefined || baseMarketSelectorValSelected === SC_BASE) && this.props.scBase !== undefined ? SC_BASE : SC_TARGET_MARKET },
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { data, scBase, activitiesListData } = this.props;
    if (data !== nextProps.data) {
      this.setState({
        chartData: processBubbleChartData(this.props.studyInfo, nextProps.data, this.props.color),
        activitiesDefaultVal: nextProps.data !== undefined ?
        _.find(activitiesListData, o =>
        _.camelCase(o.label) === _.camelCase(nextProps.data.label)) : undefined,
      });
    }
    if (scBase !== nextProps.scBase) {
      const options = _.cloneDeep(this.state.baseMarketOptions);
      options[0].label = nextProps.scBase !== undefined ? nextProps.scBase.label : undefined;
      this.setState({
        baseMarketOptions: options,
        baseMarketDefaultVal: nextProps.scBase !== undefined ? options[0] : options[1],
      });
    }
  }

  dropdownClickFn = data => {
    this.props.salesCatalystActions.setCompetitionData(data, SC_SCATTERPLOT_SC);
    this.props.getDataFn(SC_COMPETITORS_ACTIVITIES, data.label,
      this.state.baseMarketDefaultVal.value);
  }
  baseMarketDropdownClickFn = data => {
    this.setState({
      baseMarketDefaultVal: data,
    });
    this.props.salesCatalystActions.setCompetitionData(data.value, SC_BASE_MARKET_SELECTOR_VAL);
    this.props.getDataFn(SC_COMPETITORS_ACTIVITIES, this.state.activitiesDefaultVal.value,
      data.value);
  }

  getBaseMarketSelectorValForGivenFamilyId = baseMarketSelectorVal => {
    const { studyInfo } = this.props;
    const studyFamilyId = studyInfo.studyFamilyId;
    const baseMarketSelector = 'Universe/Base';
    if (!_.isEmpty(baseMarketSelectorVal) && baseMarketSelectorVal !== undefined && _.isArray(baseMarketSelectorVal)) {
      if (baseMarketSelectorVal.length > 0) {
        if (baseMarketSelectorVal[0].studyFamilyId !== undefined) {
          const index = _.findIndex(baseMarketSelectorVal, { studyFamilyId });
          if (index >= 0) {
            return baseMarketSelectorVal[index].label;
          }
        }
      }
    } else if (!_.isEmpty(baseMarketSelectorVal) && baseMarketSelectorVal !== undefined && !_.isArray(baseMarketSelectorVal)) {
      return baseMarketSelectorVal;
    }
    return baseMarketSelector;
  }

  render() {
    const { activitiesDefaultVal, baseMarketOptions, baseMarketDefaultVal } = this.state;
    const { data, activitiesListData } = this.props;
    return (
      <div className="sc-competition-block-section">
        <div className="text-align-center margin-bottom-15 clearfix">
          <h3 className="section-heading">Level of Interest/Participation</h3>
        </div>
        <div className="row margin-left-0 margin-right-0 margin-top-20">
          <div className="small-6 columns text-align-center">
            <div style={{ width: '65%', margin: 'auto' }}>
              <CommonDropdown
                listData={activitiesListData}
                defaultSelected={activitiesDefaultVal}
                itemClickFn={this.dropdownClickFn}
              />
            </div>
          </div>
          <div className="small-6 columns text-align-center">
            <div style={{ width: '65%', margin: 'auto' }}>
              <CommonDropdown
                listData={baseMarketOptions}
                defaultSelected={baseMarketDefaultVal}
                itemClickFn={this.baseMarketDropdownClickFn}
              />
            </div>
          </div>
        </div>
        <div>
          {data.subEntities !== undefined ? <div>
            <Charts config={this.state.chartData} />
            <SalesCatalystSectionBottom asteriskInfo />
          </div> : <div className="text-align-center margin-top-20 margin-bottom-10">{NO_DATA_AVAILABLE_MSG}</div>}
        </div>
      </div>
    );
  }
}

SalesCatalystCompetitionBubbleChart.propTypes = {
  data: PropTypes.shape({}),
  defaultSelected: PropTypes.shape({}),
  getDataFn: PropTypes.func,
  activitiesListData: PropTypes.arrayOf(PropTypes.shape({})),
  studyInfo: PropTypes.shape({}),
};

function mapStateToProps(state) {
  return {
    targetMarket: state.salesCatalyst.dataSelection.targetMarket,
    scBase: state.salesCatalyst.salesCatalystBase,
    baseMarketSelectorVal: state.salesCatalyst.scCompetition.baseMarketSelectorVal,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    salesCatalystActions: bindActionCreators(salesCatalystActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SalesCatalystCompetitionBubbleChart);

